import * as React from 'react';
import PropTypes from 'prop-types';
import { BiShow, BiHide } from 'react-icons/bi';
import useInput from '../hooks/useInput';

const RegisterInput = ({ register }) => {
  const [name, onNameChange, setName] = useInput('');
  const [email, onEmailChange, setEmail] = useInput('');
  const [password, onPasswordChange, setPassword] = useInput('');
  const [revealPassword, setRevealPassword] = React.useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();
    register({ name, email, password });
    setName('');
    setEmail('');
    setPassword('');
  };

  return (
    <form className="grid gap-[15px]" onSubmit={handleSubmit}>
      <div>
        <label htmlFor="name" className="mb-2 block text-base font-medium text-black">
          Name
        </label>
        <input type="text" id="name" name="name" value={name} onChange={onNameChange} className="w-full rounded-md border  p-3 text-black placeholder-[#929DA7] outline-none transition focus:border-[#F48023] active:border-[#F48023] disabled:cursor-default disabled:bg-[#F5F7FD]" placeholder="Devid Jhon" required />
      </div>
      <div>
        <label htmlFor="email" className="mb-2 block text-base font-medium text-black">
          Email
        </label>
        <input type="email" id="email" name="email" value={email} onChange={onEmailChange} className="w-full rounded-md border  p-3 text-black placeholder-[#929DA7] outline-none transition focus:border-[#F48023] active:border-[#F48023] disabled:cursor-default disabled:bg-[#F5F7FD]" placeholder="info@yourmail.com" required />
      </div>
      <div>
        <label htmlFor="password" className="mb-2 block text-base font-medium text-black">
          Password
        </label>
        <div className="relative">
          <input type={revealPassword ? '' : 'password'} id="password" name="password" value={password} onChange={onPasswordChange} className="w-full rounded-md border  p-3 text-black placeholder-[#929DA7] outline-none transition focus:border-[#F48023] active:border-[#F48023] disabled:cursor-default disabled:bg-[#F5F7FD]" placeholder="secretpassword" minLength={6} />
          {revealPassword ? (
            <BiHide className="cursor-pointer absolute top-1/2 right-4 -translate-y-1/2 text-xl opacity-50 hover:opacity-75 transition" onClick={() => setRevealPassword(false)} title="Hide Password" data-testid="hide-password-button" />
          ) : (
            <BiShow className="cursor-pointer absolute top-1/2 right-4 -translate-y-1/2 text-xl opacity-50 hover:opacity-75 transition" onClick={() => setRevealPassword(true)} title="Reveal Password" data-testid="reveal-password-button" />
          )}
        </div>
      </div>
      <button type="submit" className="bg-[#F48023] py-3 rounded-md font-black text-white text-sm mt-5 tracking-wide">REGISTER</button>
    </form>
  );
};

RegisterInput.propTypes = {
  register: PropTypes.func.isRequired,
};

export default RegisterInput;
